class ProductFeaturesExpandable extends HTMLElement {
  connectedCallback() {
    this.#details = this.querySelector('.product-features__details');
    this.#toggle = this.querySelector('.product-features__expand-btn');
    this.#expandWrap = this.querySelector('.product-features__expand-wrap');
    this.#collapsedHeight = Number(this.dataset.collapsedHeight) || 180;
    this.#labelMore = this.dataset.labelMore || 'ÜRÜNÜN TÜM ÖZELLİKLERİ';
    this.#labelLess = this.dataset.labelLess || 'DAHA AZ GÖSTER';

    if (!this.#details || !this.#toggle) return;

    this.#toggle.addEventListener('click', this.#handleToggle);
    this.#checkOverflow();

    if (typeof ResizeObserver !== 'undefined') {
      this.#observer = new ResizeObserver(() => this.#checkOverflow());
      this.#observer.observe(this.#details);
    }
  }

  disconnectedCallback() {
    this.#toggle?.removeEventListener('click', this.#handleToggle);
    this.#observer?.disconnect();
  }

  #details;
  #toggle;
  #expandWrap;
  #collapsedHeight;
  #labelMore;
  #labelLess;
  #observer;
  #expanded = false;

  #checkOverflow = () => {
    if (!this.#details || !this.#toggle || !this.#expandWrap) return;

    const needsToggle = this.#details.scrollHeight > this.#collapsedHeight + 8;

    if (!needsToggle) {
      this.#expandWrap.hidden = true;
      this.classList.remove('is-collapsed', 'is-expanded');
      this.#details.style.maxHeight = '';
      return;
    }

    this.#expandWrap.hidden = false;

    if (!this.#expanded) {
      this.classList.add('is-collapsed');
      this.classList.remove('is-expanded');
      this.#details.style.maxHeight = `${this.#collapsedHeight}px`;
      this.#toggle.setAttribute('aria-expanded', 'false');
      this.#toggle.querySelector('.product-features__expand-label').textContent = this.#labelMore;
    }
  };

  #handleToggle = () => {
    this.#expanded = !this.#expanded;

    if (this.#expanded) {
      this.classList.remove('is-collapsed');
      this.classList.add('is-expanded');
      this.#details.style.maxHeight = `${this.#details.scrollHeight}px`;
      this.#toggle.setAttribute('aria-expanded', 'true');
      this.#toggle.querySelector('.product-features__expand-label').textContent = this.#labelLess;
    } else {
      this.classList.add('is-collapsed');
      this.classList.remove('is-expanded');
      this.#details.style.maxHeight = `${this.#collapsedHeight}px`;
      this.#toggle.setAttribute('aria-expanded', 'false');
      this.#toggle.querySelector('.product-features__expand-label').textContent = this.#labelMore;
      this.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }
  };
}

if (!customElements.get('product-features-expandable')) {
  customElements.define('product-features-expandable', ProductFeaturesExpandable);
}
